export default "__VITE_ASSET__KKH1RC3j__"